import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TrackingService } from './tracking.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '../core/utils.service';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent implements OnInit {

  private entity: any;

  public trackings: any = [];
  public history_data: any = {
    columns: [],
    values: [],
    total: 0
  };
  constructor(
    private trackingService: TrackingService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private translateService: TranslateService,
    private utilsService: UtilsService
  ) { 
    this.entity = this.config.data.entity;
  }

  ngOnInit(): void {
    this.loadTracking();
  }

  loadTracking() {
    this.trackingService.history({
      _page: 0,
      _pageSize: 50,
      _sortBy: "date",
      _sortDirection: "desc",
      entity_id: this.config.data.entity_id,
      entity_pk_id: this.config.data.entity_pk_id
    }).subscribe({
      next: (data: any) => {
        //this.trackings = data.rows;
        data.values.forEach((item, idx) => {
          //dejamos abierto solo el ultimo recibido
          item.is_opened = idx == 0 ? true : false;
        });
        this.history_data = data;
      },
      error: (error: any) => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    });
  }

  toogleEvent(event: any) {
    let ret = event.is_opened ? false : true;
    event.is_opened = ret;
  }

  getColumns(mode: string) {
    let ret: any[] = [];
    if (mode == 'header') {
      let featured_entity_field_ids = [];
      if (this.entity?.metadata?.tracking?.featured_entity_field_ids != null) featured_entity_field_ids = this.entity.metadata.tracking.featured_entity_field_ids;
      ret = this.history_data.columns.filter(m => m.visible && (m.property == 'user_name' || m.property == 'tracking_date' || m.property == 'channel' || featured_entity_field_ids.includes(m.entity_field_id)));
    } else if (mode == 'detail') {
      ret = this.history_data.columns.filter(m => m.visible && m.property != 'user_name' && m.property != 'tracking_date');
    } else {
      ret = this.history_data.columns.filter(m => m.visible);
    }
    
    return ret;
  }

  getValueFor(item: any, field: any) {
    let value = item[field.property];
    let formatFn = field.formatFn;
    if (formatFn == null && field.configuration != null && field.configuration.formatFn != null) {
      formatFn = field.configuration.formatFn;
    }
    if (formatFn != null)
    {
      var format = formatFn.split("|");
      if (format[0] == "date") value = this.utilsService.formatDate(value, format);
      if (format[0] == "suffix") value = this.utilsService.formatSuffix(value, format);
      if (format[0] == "phone") value = this.utilsService.formatPhone(value, format);
      if (format[0] == "mail") value = this.utilsService.formatMail(value, format);
      if (format[0] == "www") value = this.utilsService.formatWWW(value, format);
      //if (format[0] == "badge") value = this.utilsService.formatBadge(field, row, value, format);
      //if (format[0] == "badgeColor") value = this.utilsService.formatBadgeColor(field, row, value, format);
      if (format[0] == "image") value = this.utilsService.formatImage(field, format);
      if (format[0] == "icon") value = this.utilsService.formatIcon(value, format);
      if (format[0] == "currency") value = this.utilsService.formatCurrency(value, format);
      if (format[0] == "number") value = this.utilsService.formatNumber(value, format);
    }
    if (value == null || value == "") value = " ";
    return value;
  
  }
  

  getValueForIdx(item: any, idx: number) {
    let values = Object.values(item);
    return values[idx];
  }

}
